<IDataTable [datasource]="dataSource" *transloco="let t">
  <a
    iButton
    iDataTableSuffix
    [routerLink]="isReadOnly() ? null : './create'"
    [disabled]="isReadOnly()"
    queryParamsHandling="merge"
    size="md"
  >
    <IIcon name="plus" />
    {{ t("dsp-audiences-page.create_audiences") }}
  </a>
  <table iTable>
    <thead iTableHead>
      <tr iTableRow>
        <th iTableTh>
          {{ t("common.name") }}
        </th>
        <th iTableTh>
          {{ t("common.lookback") }}
        </th>
        <th iTableTh>
          {{ t("dsp-audiences-page.audience_type") }}
        </th>
        <th iTableTh>
          {{ t("common.products") }}
        </th>
        <th iTableTh>
          {{ t("common.status") }}
        </th>
        <th iTableTh></th>
      </tr>
    </thead>
    <tbody>
      @for (audience of dataSource.data(); track audience.audienceId) {
        <tr iTableRow>
          <td iTableTd>{{ audience.audienceName }}</td>
          <td iTableTd>
            {{ t(audience.lookback ? "common.days_count" : "common.unknown", { count: audience.lookback }) }}
          </td>
          <td iTableTd>
            {{ t(audience.audienceType ? "dsp-audiences-type." + audience.audienceType : "common.unknown") }}
          </td>
          <td iTableTd>
            @if (audience.asins?.length) {
              <button iButton variant="secondary" size="xs" (click)="openAsinModal(audience)">
                {{ t("common.asins_count", { count: audience.asins?.length }) }}
              </button>
            }
          </td>
          <td iTableTd>
            <IBadge
              [label]="audience.status"
              [color]="
                audience.status === AudienceStatus.Active
                  ? 'white'
                  : audience.status === AudienceStatus.Failed
                    ? 'red'
                    : 'gray'
              "
            ></IBadge>
          </td>
          <td>
            @let isDeletable = audience.status === AudienceStatus.Active || audience.status === AudienceStatus.Failed;
            <button
              iButton
              variant="secondary"
              size="xs"
              [iTooltip]="
                isDeletable ? t('common.delete') : t('dsp-audiences-page.cannot_delete_pending_or_processing_audience')
              "
              [disabled]="isReadOnly() || !isDeletable || !!deletingAudienceId()"
              [loading]="deletingAudienceId() === audience.audienceId"
              (click)="openDeleteConfirmationModal(audience)"
            >
              <IIcon name="trash" />
            </button>
          </td>
        </tr>
      } @empty {
        <tr>
          <td colspan="100%" class="py-4 text-center text-sm text-gray-700">
            {{ t("dsp-audiences-page.no_audience_found") }}
          </td>
        </tr>
      }
    </tbody>
  </table>
</IDataTable>
